import _ from 'lodash'

const state = {
  isNavigationOpen: false,
  isCartOpen: false,
  isCartDocked: false,
  isSearchOpen: false,
  activeSearchItem: null,
  isMarketSelectorOpen: false,
  isLargeMedia: false,
  largeMediaSize: 0,
  isAccountOptionsOpen: false,
  useVat: false,
  showTechnicalnformation: false,
  showCompareProducts: false,
  shownMessages: [],
  forceView: null,
  useListView: true,
  activeXhrConfigs: [],
  notifications: [],
  selectedFractions: [],
  searchQuery: null,
  hasAcceptedCookies: false,
  previousMarket: null,
  activeTechnicalInformationBlocks: [],
  isVehicleInformationOpen: false,
  searchTabs: [],
  showDesktopFilter: true,
  activeSlideIn: null
}

const mutations = {
  toggle_value(state, payload) {
    state[payload.key] = payload.data === undefined ? !state[payload.key] : payload.data
  },
  dismiss_message(state, payload) {
    if (state.shownMessages.find(m => m === payload) === undefined) {
      state.shownMessages.push(payload)
    }
  },
  update_active_xhr_configs(state, payload) {
    state.activeXhrConfigs = payload
  },
  add_notification(state, payload) {
    state.notifications.push(payload)
  },
  set_search_query(state, payload) {
    state.searchQuery = payload
  },
  update_selected_fractions(state, payload) {
    state.selectedFractions = payload
  },
  set_active_search_item(state, payload) {
    state.activeSearchItem = payload
  },
  set_large_media_size(state, payload) {
    state.largeMediaSize = payload
  },
  set_accept_cookies(state, payload) {
    state.hasAcceptedCookies = payload
  },
  set_previous_market(state, payload) {
    state.previousMarket = payload
  },
  toggle_active_technical_information_block(state, payload) {
    state.activeTechnicalInformationBlocks = _.xor(state.activeTechnicalInformationBlocks, [payload])
  },
  set_active_search_tab(state, payload) {
    state.searchTabs = payload
  },
  set_active_slide_in(state, payload) {
    state.activeSlideIn = payload
  }
}

const actions = {
  updateSelectedFractions({ commit }, payload) {
    commit('update_selected_fractions', payload)
  },
  toggleValue: ({ commit }, payload) => {
    commit('toggle_value', payload)
  },
  dismissMessage: ({ commit }, payload) => {
    commit('dismiss_message', payload)
  },
  updateActiveXhrConfigs({ commit }, payload) {
    commit('update_active_xhr_configs', payload)
  },
  addNotification({ commit }, payload) {
    commit('add_notification', payload)
  },
  setSearchQuery({ commit }, payload) {
    commit('set_search_query', payload)
  },
  setActiveSearchItem({ commit }, payload) {
    commit('set_active_search_item', payload)
  },
  setLargeMediaSize({ commit }, payload) {
    commit('set_large_media_size', payload)
  },
  acceptCookies({ commit }, payload) {
    commit('set_accept_cookies', payload)
  },
  setPreviousMarket({ commit }, payload) {
    commit('set_previous_market', payload)
  },
  toggleActiveTechnicalInformationBlock({ commit }, payload) {
    commit('toggle_active_technical_information_block', payload)
  },
  setActiveSearchTab({ commit, state }, payload) {
    const tabs = state.searchTabs.map((t) => {
      t.isActive = payload && t.name === payload.name

      return t
    })

    commit('set_active_search_tab', tabs)
  },
  initSearchTabs({ commit }, payload) {
    commit('set_active_search_tab', payload)
  },
  setActiveSlideIn({ commit }, payload) {
    commit('set_active_slide_in', payload)
  }
}

const getters = {
  isNavigationOpen: state => state.isNavigationOpen,
  isCartOpen: state => state.isCartOpen,
  isCartDocked: state => state.isCartDocked,
  isSearchOpen: state => state.isSearchOpen,
  isMarketSelectorOpen: state => state.isMarketSelectorOpen,
  isLargeMedia: state => state.isLargeMedia,
  largeMediaSize: state => state.largeMediaSize,
  isAccountOptionsOpen: state => state.isAccountOptionsOpen,
  isMessageShow: state => (id) => state.shownMessages.find(m => m === id) === undefined,
  useVat: state => state.useVat,
  showTechnicalnformation: state => state.showTechnicalnformation,
  showCompareProducts: state => state.showCompareProducts,
  shownMessages: state => (id) => state.shownMessages.find(m => m === id),
  useListView: state => state.useListView,
  useGridView: state => !state.useListView,
  forceListView: state => state.forceView === 'list',
  forceGridView: state => state.forceView === 'grid',
  activeEndpoints: state => state.activeXhrConfigs,
  notifications: state => state.notifications,
  selectedFractions: state => state.selectedFractions,
  lastSearchQuery: state => state.searchQuery,
  activeSearchItem: state => state.activeSearchItem,
  hasAcceptedCookies: state => state.hasAcceptedCookies,
  previousMarket: state => state.previousMarket,
  isTechnicalInformationBlockActive: state => (id) => {
    return state.activeTechnicalInformationBlocks.includes(id)
  },
  isVehicleInformationOpen: state => state.isVehicleInformationOpen,

  searchTabs: state => state.searchTabs,
  showDesktopFilter: state => state.showDesktopFilter,
  activeSlideIn: state => state.activeSlideIn,
  isSlideInActive: state => name => {
    return state.activeSlideIn === name
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
